import { useParams, Link } from "react-router-dom";
import { beritaData } from "../../data/beritaData";
import { useNewsDetail } from "../../hooks/useNewsDetail";

const DetailBerita = () => {
    const { id } = useParams();
    const { data: berita } = useNewsDetail(id);

    // Jika berita kosong/null atau array kosong, tampilkan pesan
    if (!berita || (Array.isArray(berita) && berita.length === 0)) {
        return (
            <div className="text-center py-10 text-gray-500 font-inter">
                Berita tidak ditemukan.
            </div>
        );
    }

    // Pastikan berita adalah objek, kalau array ambil index 0
    const currentBerita = Array.isArray(berita) ? berita[0] : berita;

    // Filter berita terkait (exclude berita yg sedang ditampilkan)
    const beritaTerkait = beritaData.filter(
        (item) => item.id.toString() !== id
    );

    return (
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            {/* Breadcrumb */}
            <nav
                className="text-sm text-gray-500 mb-3 font-inter"
                aria-label="Breadcrumb"
            >
                <Link to="/" className="hover:underline">
                    Beranda
                </Link>{" "}
                /{" "}
                <Link to="/berita" className="hover:underline">
                    Berita
                </Link>
            </nav>

            {/* Judul dan Tanggal */}
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1 leading-tight font-pontano">
                {currentBerita.judul}
            </h1>
            <p className="text-sm text-gray-500 mb-4 font-inter">
                Ditulis: {currentBerita.created_at}
            </p>

            {/* Gambar utama */}
            {currentBerita.thumbnail && (
                <div className="w-full mb-6 relative overflow-hidden flex justify-center">
                    <img
                        src={currentBerita.thumbnail}
                        alt={currentBerita.judul}
                        className="w-full max-h-96 object-contain"
                    />
                </div>
            )}

            {/* Galeri Foto */}
            {currentBerita.galeri?.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
                    {currentBerita.galeri.slice(0, 3).map((src, idx) => (
                        <div
                            key={idx}
                            className="w-full overflow-hidden aspect-w-16 aspect-h-9"
                        >
                            <img
                                src={src}
                                alt={`galeri-${idx}`}
                                className="w-full h-full object-cover"
                            />
                        </div>
                    ))}
                </div>
            )}

            {/* Keterangan HTML (konten dengan gambar base64) */}
            <article
                className="
    prose prose-lg max-w-none text-gray-700 mb-8 font-inter
    [&_ol]:list-decimal [&_ul]:list-disc
    [&_li]:list-item
    [&_ol]:pl-6 [&_ul]:pl-6
    [&_li>p]:m-0
  "
                dangerouslySetInnerHTML={{ __html: currentBerita.keterangan }}
            />

            {/* Foto oleh Admin */}
            <div className="flex justify-between items-center mb-3">
                <h2 className="text-xs font-medium font-inter text-gray-400">
                    Foto Oleh Admin
                </h2>
            </div>

            {/* Content biasa jika ada */}
            {currentBerita.content && (
                <div className="text-gray-500 text-base leading-relaxed mb-8 font-inter">
                    {currentBerita.content}
                </div>
            )}

            {/* Berita Terkait */}
            {/* <div className="mt-12">
                <h2 className="text-lg font-semibold mb-4 font-pontano">
                    Berita Terkait
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {beritaTerkait.map((item) => (
                        <div
                            key={item.id}
                            className="overflow-hidden hover:shadow-md transition-all duration-300 flex flex-col h-full"
                        >
                            <img
                                src={item.image}
                                alt={item.judul}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-4 flex flex-col justify-between flex-grow">
                                <h3 className="text-sm font-bold text-gray-900 leading-tight line-clamp-2 font-pontano">
                                    {item.judul}
                                </h3>
                                <p className="text-xs text-gray-500 mt-2 line-clamp-2 font-inter">
                                    {item.summary}
                                </p>
                                <div className="mt-auto flex justify-center">
                                    <Link
                                        to={`/berita/${item.id}`}
                                        className="text-sm text-redPrimary font-bold mt-3 inline-flex items-center gap-1"
                                    >
                                        Selengkapnya
                                        <img
                                            src="/images/asset/arrow.svg"
                                            alt="arrow"
                                            className="w-4 h-4 object-contain"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div> */}
        </div>
    );
};

export default DetailBerita;
